import { render, staticRenderFns } from "./ComplianceElementsWithNoLocationDrillDown.vue?vue&type=template&id=8a6b7ce0&"
import script from "./ComplianceElementsWithNoLocationDrillDown.vue?vue&type=script&lang=ts&"
export * from "./ComplianceElementsWithNoLocationDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports